import React from 'react'
import Navegador from '../components/Navegador'
import FormNuevo from '../components/FormNuevo'
import ruta from '../routes/api-routes'
import axios from 'axios'

class NuevoCarro extends React.Component {
    state = {
        form: {
            brand: '',
            model: '',
            year: '2019',
            price: '',
            color: '',
            km: '0',
            transmission: 'Manual', 
            doors: '4', 
            gas: 'Normal', 
            fuelCap: '',
            engine: '', 
            horsepower: '',
            descrip: '',
            picturePath: '',
            used: false
        },
        error: "",
        editing: false,
        carId: '',
        pageInfo: {
            title: 'Agregar nuevo carro',
            buttonText: 'Agregar'
        }
    }

    // This get data from the API endpoint
    async componentDidMount(){
        // If there is a parameter after the link this is gonna request data
        if(this.props.match.params.id) {
            const idCarro = this.props.match.params.id
            const res = await axios.get(ruta.editarCarro+idCarro)
            // The state will change to show a diferent screen
            this.setState({
                editing: true,
                carId: this.props.match.params.id,
                pageInfo: {
                    title: 'Editar el carro',
                    buttonText: 'Guardar cambios'
                },
                form: res.data
            })
            console.log(res.data)
        }
    }

    // Handle change works when a key is pressed on the form
    handleChange = e => {
        this.setState({
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value
            }
        })
    }

    handleSubmit = async e => {
        e.preventDefault()
        try {
            // Editing a new car
            if(this.state.editing){
                const res = await axios.put(ruta.editarCarro + this.state.carId, this.state.form)
                console.log(res);
            }
            // Creating a new car
            else{
                const res = await axios.post(ruta.nuevoCarro, this.state.form)
                console.log(res);
            }
            // Redirect to /menu after submit
            this.props.history.push('/menu')
        } catch (error) {
            console.log(error)
        }
    } 
    
    render(){
        return (
            <React.Fragment>
                <Navegador/>
                <FormNuevo
                onSubmit={this.handleSubmit}
                onChange={this.handleChange}
                form={this.state.form}
                pageInfo={this.state.pageInfo}
                />
            </React.Fragment>
        )
    }
}

export default NuevoCarro